import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import dogReadList from './images/dog_read_list.png';
import logoImage from '../Header/images/AnnaLogo.svg';
import styles from './styles.module.css';
import ApiClientInstance from '../../common/ApiClient';

class ViewSelecting extends Component {
  onAccountantClick = () => {
    window.location.href = `${ApiClientInstance.websiteUrl}/free-tools/vat-filing/accountants/dashboard/clients?forceLogin=true`;
  }

  onCustomerClick = () => {
    window.location.href = `${ApiClientInstance.publicApiUrl}/company`;
  }

  render() {
    return (
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <img src={logoImage} className={styles.logo} alt="logo" />
        </div>
        <div className={styles.main}>
          <div className={styles.content}>
            <h2 className={styles.name}>ANNA for accountants</h2>
            <h3 className={styles.title}>Desktop access</h3>
            <p className={styles.description}>
              Please select a version of the view that best suits your needs:
            </p>
            <div className={styles.buttons}>
              <div className={styles.buttonContainer}>
                <button type="button" className={styles.button} onClick={this.onAccountantClick}>I’m an accountant</button>
                <span className={styles.hint}>*Opens accountant’s dashboard</span>
              </div>
              <div className={styles.buttonContainer}>
                <button type="button" className={styles.button} onClick={this.onCustomerClick}>I’m a customer of ANNA</button>
                <span className={styles.hint}>*Opens the desktop view directly</span>
              </div>
            </div>
          </div>
          <div className={styles.imageContainer}>
            <img src={dogReadList} className={styles.image} alt="dog read list" />
          </div>
        </div>
      </div>
    );
  }
}

ViewSelecting.propTypes = {
  company: PropTypes.shape({
    sort_code: PropTypes.string,
    account_number: PropTypes.string,
    title: PropTypes.string,
    company_type: PropTypes.string,
    address: PropTypes.string,
  }),
  account: PropTypes.shape({
    company_type: PropTypes.string,
    title: PropTypes.string,
    source: PropTypes.string,
    details: PropTypes.shape({
      sort_code: PropTypes.string,
    }),
  }),
};

const mapStateToProps = ({ appService, accountService }) => ({
  company: accountService.company,
  account: accountService.account,
  alias: appService.alias,
});

ViewSelecting.defaultProps = {
  company: null,
  account: null,
};

export default connect(mapStateToProps)(ViewSelecting);
